import React, { useState } from 'react';
import { useClassName } from 'common/hooks';
import { Loader } from 'common/lazy';
import './youtube-with-poster.less';

const YoutubeWithPoster = ({ url, posterUrl }) => {
  const className = useClassName('YoutubeWithPoster');
  const [isPlaying, setIsPlaying] = useState(false);
  const [loadingIframe, setLoadingIframe] = useState(true);

  const getVideoId = () => {
    const urlObj = new URL(url);
    return urlObj.searchParams.get('v');
  };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div className={className('youtube-wrapper')}>
      {!isPlaying ? (
        <div onClick={handlePlay} className={className('poster-container')}>
          <img src={posterUrl} alt="Poster" className={className('poster')} />
        </div>
      ) : (
        <div className={className('fade-in')}>
          {loadingIframe && <Loader active />}
          <iframe
            style={{ width: '100%', height: '100%' }}
            onLoad={() => {
              if (loadingIframe) setLoadingIframe(false);
            }}
            src={`https://www.youtube.com/embed/${getVideoId()}?autoplay=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen></iframe>
        </div>
      )}
    </div>
  );
};

export default YoutubeWithPoster;
